import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeOCClaimPrintForm } from './normalize';

export const fetchOCClaimPrintForm = createProvider(api.fetchOCClaimPrintForm)
  .andThen((res) => normalizeOCClaimPrintForm(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
